import {call, put} from "redux-saga/effects";
import {getHistorySouscriptionsApi} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/historiqueSouscriptionActions";

export function* getHistorySouscriptionsSaga({ payload }) {
  try {
    const response = yield call(getHistorySouscriptionsApi, payload);
    yield put(actions.getHistorySouscriptionsSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getHistorySouscriptionsFailAction(error));
  }
}
